<template>
  <div class="footer">
    <ul class="menuList">
      <li
        v-for="(menu, idx) in menuList"
        :key="idx"
      >
        <a
          :href="menu.url"
          :target="/^https/.test(menu.url) ? '_blank' : false"
        >{{ menu.name }}</a>
      </li>
    </ul>
    <div class="inc">&copy;ZAPPALLAS, INC. 2022</div>
  </div>
</template>

<script>
import getUlmarEnvDomain from '@/utils/getUlmarEnvDomain'

export default {
  name: 'FooterUlmar',
  data() {
    return {
      envDomain: getUlmarEnvDomain(),
      menuList: [
        { name: '運営会社', url: 'https://www.zappallas.com/'},
        { name: '利用規約', url: `${getUlmarEnvDomain()}terms`},
        { name: 'ご利用ガイド(FAQ)', url: `${getUlmarEnvDomain()}faq`},
        { name: 'プライバシーポリシー', url: `${getUlmarEnvDomain()}privacy`},
        { name: '特定商取引法に基づく表記', url: `${getUlmarEnvDomain()}legal`},
        { name: 'お問い合わせ', url: `${getUlmarEnvDomain()}inquiry`},
      ],
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../sass/commons/commonVariables.scss';

.footer {
  background: #CDB0A1;
  margin: 0 auto;

  .menuList {
    padding: 12px 10.667%;
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    font-size: 11px;
    line-height: 16px;
    color: #fff;
    > li {
      list-style: none;
      flex: 0 1 50%;
      padding: 0;
      > a {
        color: inherit;
        text-decoration: none;
        display: block;
        padding: 12px 0;
        margin-right: -10px;
      }
    }
    @include mq('w580') {
      justify-content: center;
      > li {
        flex-basis: auto;
        padding: 0 13px;
      }
    }
    @include mq('pc') {
      padding: 32px 0 28px;
    }
  }
  .inc {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.3em;
    color: #FFFFFF;
    padding: 0 0 16px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Ulmar/partials/FooterUlmar.vue